import * as yup from "yup";
import {maxNumberYupLimit} from "../../constants";
import {SelectElementModelFE} from "../../api/types/generic";

export const initialReportFormModel = (legalEntityOptions: SelectElementModelFE[], dealerOption: SelectElementModelFE[]) => ({
    type: null,
    dealer: dealerOption.length === 1 ? dealerOption[0] : null,
    legalEntity: legalEntityOptions.length === 1 ? legalEntityOptions[0] : null,
    incomingReservation: {
        locationsGroupIds: null,
        dayFromReservationDate: 0,
        numberOfMonths: 0,
        startMonthPickUp: "",
        year: null
    },
    competitorsBenchmark: {
        from: null,
        to: null,
        rentalPeriod: [],
        locationPickUp: null,
        locationDropOff: null,
        site: ""
    },
    numberOfReservations: {
        startMonthPickUp: "",
        numberOfMonths: 0,
        dateType: null,
        locationsGroupIds: [],
        startDate: null,
        endDate: null,
        smCommercialSegmentId: null,
        year: null
    },
    numberOfDaysOfReservations: {
        startMonthPickUp: "",
        numberOfMonths: 0,
        dateType: null,
        locationsGroupIds: [],
        startDate: null,
        endDate: null,
        smCommercialSegmentId: null,
        year: null
    },
    averageRpd: {
        startMonthPickUp: "",
        numberOfMonths: 0,
        dateType: null,
        locationsIds: [],
        locationsGroupIds: [],
        startDate: null,
        endDate: null,
        smCommercialSegmentId: null,
        year: null
    },
    revenues: {
        startMonthPickUp: "",
        numberOfMonths: 0,
        dateType: null,
        locationsGroupIds: [],
        startDate: null,
        endDate: null,
        smCommercialSegmentId: null,
        year: null
    },
    numberOfReservationsCarGroups: {
        startDate: null,
        endDate: null,
        carGroups: [],
        smCommercialSegmentId: null
    },
    utilizationAndAvailability: {
        location: null,
        currentMonthSelected: false
    }
});

export const reportValidationSchema = (t: Function) => {
    return yup.object().shape({
        type: yup
            .object()
            .shape({
                code: yup.string(),
                label: yup.string()
            })
            .nullable()
            .required(t("translation:validation.fieldMandatory")),
        dealer: yup
            .object()
            .shape({
                code: yup.string(),
                label: yup.string()
            })
            .nullable()
            .required(t("translation:validation.fieldMandatory")),
        legalEntity: yup
            .object()
            .shape({
                code: yup.string(),
                label: yup.string()
            })
            .nullable()
            .required(t("translation:validation.fieldMandatory")),
        incomingReservation: yup.object().shape({
            locationsGroupIds: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            dayFromReservationDate: yup
                .number()
                .typeError(t("translation:validation.fieldMandatory"))
                .nullable()
                .min(1, t("translation:validation.fieldMandatory"))
                .max(maxNumberYupLimit, t("pricing:validation.numberLowerThan") + maxNumberYupLimit)
                .integer(t("pricing:alert.errors.integer"))
                .required(t("translation:validation.fieldMandatory")),
            numberOfMonths: yup
                .number()
                .typeError(t("translation:validation.fieldMandatory"))
                .nullable()
                .min(1, t("translation:validation.fieldMandatory"))
                .max(maxNumberYupLimit, t("pricing:validation.numberLowerThan") + maxNumberYupLimit)
                .integer(t("pricing:alert.errors.integer"))
                .required(t("translation:validation.fieldMandatory")),
            startMonthPickUp: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory"))
        }),
        competitorsBenchmark: yup.object().shape({
            from: yup
                .date()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            rentalPeriod: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .number()
                        .integer(t("pricing:alert.errors.integer"))
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                )
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            locationPickUp: yup
                .string()

                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            locationDropOff: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            site: yup
                .string()
                .required(t("translation:validation.fieldMandatory"))
        }),
        numberOfReservations: yup.object().shape({
            startMonthPickUp: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            numberOfMonths: yup
                .number()
                .typeError(t("translation:validation.fieldMandatory"))
                .nullable()
                .min(1, t("translation:validation.fieldMandatory"))
                .max(maxNumberYupLimit, t("pricing:validation.numberLowerThan") + maxNumberYupLimit)
                .integer(t("pricing:alert.errors.integer"))
                .required(t("translation:validation.fieldMandatory")),
            dateType: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            locationsGroupIds: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .object()
                        .shape({
                            code: yup.string(),
                            label: yup.string()
                        })
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                ),
            startDate: yup
                .date()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            endDate: yup
                .date()
                .nullable()
                .min(
                    yup.ref("startDate"),
                    t("pricing:rentalPeriods.form.errors.greaterThan")
                ),
            smCommercialSegmentId: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
        }),
        numberOfDaysOfReservations: yup.object().shape({
            startMonthPickUp: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            numberOfMonths: yup
                .number()
                .typeError(t("translation:validation.fieldMandatory"))
                .nullable()
                .min(1, t("translation:validation.fieldMandatory"))
                .max(maxNumberYupLimit, t("pricing:validation.numberLowerThan") + maxNumberYupLimit)
                .integer(t("pricing:alert.errors.integer"))
                .required(t("translation:validation.fieldMandatory")),
            dateType: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            locationsGroupIds: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .object()
                        .shape({
                            code: yup.string(),
                            label: yup.string()
                        })
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                ),
            startDate: yup
                .date()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            endDate: yup
                .date()
                .nullable()
                .min(
                    yup.ref("startDate"),
                    t("pricing:rentalPeriods.form.errors.greaterThan")
                ),
            smCommercialSegmentId: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
        }),
        averageRpd: yup.object().shape({
            startMonthPickUp: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            numberOfMonths: yup
                .number()
                .typeError(t("translation:validation.fieldMandatory"))
                .nullable()
                .min(1, t("translation:validation.fieldMandatory"))
                .max(maxNumberYupLimit, t("pricing:validation.numberLowerThan") + maxNumberYupLimit)
                .integer(t("pricing:alert.errors.integer"))
                .required(t("translation:validation.fieldMandatory")),
            dateType: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            locationsIds: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .object()
                        .shape({
                            code: yup.string(),
                            label: yup.string()
                        })
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                ),
            locationsGroupIds: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .object()
                        .shape({
                            code: yup.string(),
                            label: yup.string()
                        })
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                ),
            startDate: yup
                .date()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            endDate: yup
                .date()
                .nullable()
                .min(
                    yup.ref("startDate"),
                    t("pricing:rentalPeriods.form.errors.greaterThan")
                ),
            smCommercialSegmentId: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
        }),
        revenues: yup.object().shape({
            startMonthPickUp: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            numberOfMonths: yup
                .number()
                .typeError(t("translation:validation.fieldMandatory"))
                .nullable()
                .min(1, t("translation:validation.fieldMandatory"))
                .max(maxNumberYupLimit, t("pricing:validation.numberLowerThan") + maxNumberYupLimit)
                .integer(t("pricing:alert.errors.integer"))
                .required(t("translation:validation.fieldMandatory")),
            dateType: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            locationsGroupIds: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .object()
                        .shape({
                            code: yup.string(),
                            label: yup.string()
                        })
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                ),
            startDate: yup
                .date()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            endDate: yup
                .date()
                .nullable()
                .min(
                    yup.ref("startDate"),
                    t("pricing:rentalPeriods.form.errors.greaterThan")
                ),
            smCommercialSegmentId: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory"))
        }),
        numberOfReservationsCarGroups: yup.object().shape({
            startDate: yup
                .date()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            endDate: yup
                .date()
                .nullable()
                .min(
                    yup.ref("startDate"),
                    t("pricing:rentalPeriods.form.errors.greaterThan")
                )
                .required(t("translation:validation.fieldMandatory")),
            smCommercialSegmentId: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            carGroups: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .string()
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                )
        }),
        utilizationAndAvailability: yup.object().shape({
            location: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory"))
        })
    });
};